import { t } from 'i18next'

import { Contract, ContractTenant } from '../../../../../common/validations'
import {
  ContractChangesSection,
  TerminationDisallowedReason,
} from '../../../../../common/types'
import { hasActiveTermination } from '../../utils/hasActiveTermination'
import { isAdultTenant } from '../../utils/isAdultTenant'

const NO_FURTHER_CHANGES_REASONS: TerminationDisallowedReason[] = [
  TerminationDisallowedReason.CONTRACT_TERMINATED,
  TerminationDisallowedReason.CONTRACT_EXPIRED,
  TerminationDisallowedReason.TENANT_MOVED_OUT,
]

export const resolvePendingContractChangesNotice = (
  contract: Contract,
  tenants: ContractTenant[],
  otherSection: ContractChangesSection
) => {
  const reason = contract.terminationDisallowedReason

  if (
    !hasActiveTermination(contract, tenants) ||
    (reason !== undefined && NO_FURTHER_CHANGES_REASONS.includes(reason))
  ) {
    return undefined
  }

  if (otherSection === ContractChangesSection.TERMINATE_CONTRACT) {
    return reason === undefined ||
      reason === TerminationDisallowedReason.NOT_CONTRACT_PARTY
      ? t('contractModification:residentChanges.pendingContractChanges')
      : undefined
  }

  const currentTenant = tenants.find(
    (tenant) => tenant.id === contract.tenant.id
  )

  return currentTenant !== undefined &&
    isAdultTenant(currentTenant) &&
    !currentTenant.isContractParty
    ? t('terminateContract:terminationDisallowedReason.pendingContractParty')
    : undefined
}
